import { AUTO, Scale } from "phaser";
import CONSTANTS from "./constants";
import MainScene from "./main";

const size = {
  width: CONSTANTS.WIDTH,
  height: CONSTANTS.HEIGHT
};

const gameConfig = (width, height, mobile) => {
  const dimensions = mobile ? { width, height } : size;
  return {
    type: AUTO,
    scale: {
      mode: Scale.FIT,
      autoCenter: Scale.CENTER_BOTH,
      ...dimensions,
      max: dimensions
    },
    render: {
      antialias: false,
      pixelArt: false,
      roundPixels: true
    },
    dom: {
      createContainer: true
    },
    scene: [MainScene]
  };
};

export default gameConfig;
